export default defineNuxtPlugin(() => {
  onNuxtReady(() => {
    console.log("Alfred version: ".concat(process.env.ALFRED_VERSION));
    console.log("Nuxt alfred version: ".concat(__NUXT__.config.public.alfredVersion));
    if (__NUXT__.config.public.alfredVersion !== process.env.ALFRED_VERSION) {
      console.error('Alfred version mismatch');
    }
  });
});